document.addEventListener('DOMContentLoaded', () => {
  const scroller = document.querySelector('.trending-products-scroller');
  if (!scroller) {
    return;
  }

  let isDown = false;
  let isDragging = false;
  let startX;
  let scrollLeft;

  scroller.addEventListener('mousedown', (e) => {
    // We only want to drag with the main mouse button
    if (e.button !== 0) return;
    
    isDown = true;
    isDragging = false; // Reset on new mousedown
    scroller.classList.add('grabbing');
    startX = e.pageX - scroller.offsetLeft;
    scrollLeft = scroller.scrollLeft;
  });

  scroller.addEventListener('mouseleave', () => {
    isDown = false;
    scroller.classList.remove('grabbing');
  });

  scroller.addEventListener('mouseup', () => {
    isDown = false;
    scroller.classList.remove('grabbing');
  });

  scroller.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    
    // A small movement is tolerated and not considered a drag
    if (Math.abs(e.pageX - (scroller.offsetLeft - scrollLeft) - startX) > 5) {
      isDragging = true;
    }
    
    if (!isDragging) return;
    
    e.preventDefault();
    const x = e.pageX - scroller.offsetLeft;
    const walk = (x - startX) * 2; //scroll-fast
    scroller.scrollLeft = scrollLeft - walk;
  });
  
  // Prevent click on links after dragging
  const links = scroller.querySelectorAll('.trending-product-card__link');
  links.forEach(link => {
    const media = link.querySelector('img, video');
    if (media) {
        media.addEventListener('dragstart', (e) => e.preventDefault());
    }

    link.addEventListener('click', (e) => {
      if (isDragging) {
        e.preventDefault();
      }
    });
  });
}); 